import HomeIcon from '@mui/icons-material/Home'
import { Box, Breadcrumbs, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

import { BreadcrumbStyles } from 'components/Shared/Breadcrumb/Styles'

const MobileViewBreadCrumbs = (props: CommonBreadcrumbs) => {
  const { items } = props
  const lastCrumb = items[items.length - 1]

  return (
    <Box role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        <Link data-testid="participant-breadcrumb-dashboard" to="/adm">
          <HomeIcon sx={BreadcrumbStyles.iconStyles} />
        </Link>
        <Link
          data-testid="participant-breadcrumb-dashboard"
          to="#"
          style={{ textDecoration: 'none' }}
        >
          <Typography color="text.primary">...</Typography>
        </Link>
        <Link to={lastCrumb.link}>
          <Typography color="text.primary">{lastCrumb.name}</Typography>
        </Link>
      </Breadcrumbs>
    </Box>
  )
}

export default MobileViewBreadCrumbs
